<div class="flex w-full p-4 border-b border-b-latte">
    <div class="flex flex-row items-center justify-start gap-2">
        @if (showBackButton && panelOpen) {
            <p-button
                class="mr-auto"
                (click)="onBack()"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="aspect-square"
                icon="pi pi-arrow-left" />
        }

        @if (sendToMainPanelUrl && panelOpen) {
            <p-button
                (click)="onClickSendToMainPanel()"
                class="mr-auto"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="aspect-square"
                icon="pi pi-expand" />
        }

        @if (showReloadButton && panelOpen) {
            <p-button
                class="mr-auto"
                (click)="onClickRefresh()"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="aspect-square"
                icon="pi pi-sync" />
        }
    </div>
    <!-- Panel toggle -->
    <p-button
        class="ml-auto"
        (click)="onTogglePanel()"
        severity="secondary"
        [outlined]="true"
        size="small"
        styleClass="aspect-square"
        [icon]="panelOpen ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'" />
</div>
